import { useScriptGoogleAnalytics, useScriptGoogleTagManager, useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleTagManager = useScriptGoogleTagManager({"id":"GTM-TP9FTD"})
    const googleAnalytics = useScriptGoogleAnalytics({"id":"G-Y1YYWW2NEL"})
    return { provide: { $scripts: { googleTagManager, googleAnalytics } } }
  }
})